export default __webpack_public_path__ + "static/media/MOC.68d0caee.png";